

export const getContentStyle = (toolbarPosition) => {
    switch (toolbarPosition) {
        case 'left':
            return { marginLeft: '60px', width: 'calc(100% - 60px)' };
        case 'right':
            return { marginRight: '60px', width: 'calc(100% - 60px)' };
        case 'top':
            return { marginTop: '60px', height: 'calc(100% - 60px)' };
        case 'bottom':
            return { marginBottom: '60px', height: 'calc(100% - 60px)' };
        default:
            return {};
    }
};